<template>
    <div class="uploadFile">
        <el-dialog title="上传附件" :visible="uploadShow" width="50%" @close="uploadClose">
            <div class="upload-area" @drop="handleDrop" @dragover="handleDragover" @click="triggerFileInput">
                <div class="upload-icon">
                    <i class="el-icon-upload"></i>
                </div>
                <p>将文件拖到此处，或<el-button type="text">点击上传</el-button></p>
                <input type="file" ref="fileInput" multiple @change="handleFileSelect" style="display: none">
            </div>
            <div v-if="selectedFiles.length > 0" style="margin-top: 15px;">
                <h4>已选择文件：</h4>
                <ul style="margin: 10px 0; padding-left: 20px;">
                    <li v-for="file in selectedFiles" :key="file.name" style="margin: 5px 0;">
                        {{ file.name }} ({{ formatFileSize(file.size) }})
                    </li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <div>
                    <p v-if="uploading">上传进度: {{ uploadProgress }}%</p>
                    <el-button type="primary" @click="uploadFiles" :loading="uploading" size="small">
                        {{ uploading ? '上传中...' : '确认上传' }}
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { uploadFileApi } from '@/Api/fileApi'
export default {
    mame: 'uploadFile',
    props: {
        uploadShow: {
            type: Boolean,
            default: false,
        },
        currentRow: {
            type: Object,
            default: undefined,
        },
        tableName: {
            type: String,
            default: 'default',
        },
    },
    data() {
        return {
            selectedFiles: [],
            uploading: false,
            uploadProgress: 0
        }
    },
    methods: {
        uploadClose() {
            this.selectedFiles = []
            this.uploadProgress = 0
            this.$emit('uploadClose', '')
        },
        // 处理拖拽放置
        handleDrop(event) {
            event.preventDefault();
            this.selectedFiles = [...this.selectedFiles, ...Array.from(event.dataTransfer.files)]
            this.uploadProgress = 0
        },

        // 处理拖拽悬停
        handleDragover(event) {
            event.preventDefault();
        },
        // 触发文件选择
        triggerFileInput() {
            this.$refs.fileInput.click();
        },

        // 处理文件选择
        handleFileSelect(event) {
            this.selectedFiles = [...this.selectedFiles, ...Array.from(event.target.files)]
            this.uploadProgress = 0
            event.target.value = ''
        },

        // 上传文件
        uploadFiles() {
            if (this.selectedFiles.length === 0) {
                this.$message.warning('请选择要上传的文件');
                return;
            }

            this.uploading = true;

            // 实际项目中这里应该调用上传API
            const formData = new FormData();
            this.selectedFiles.forEach(file => {
                formData.append('files', file);
                formData.append('foreignKeys', this.currentRow?.id || this.currentRow?.formCode || '');
                formData.append('fileTypes', file.name.split('.').pop());
            });

            // 添加其他参数
            if (this.currentRow) {
                if (this.tableName == 'sent_form') {
                    formData.append('filePath', `供应商发货附件\\外购件\\${this.currentRow?.projectName || ''}\\${this.currentRow?.supplier || ''}\\${this.currentRow?.formId || ''}`);
                } else if (this.tableName == 'purchase_form') {
                    formData.append('filePath', `供应商发货附件\\外购件\\${this.currentRow?.project?.trackId || ''}${this.currentRow?.projectName || ''}\\${this.currentRow?.supplier || ''}\\${this.currentRow?.formId || ''}`);
                } else if (this.tableName == 'proc_sent_form') {
                    formData.append('filePath', `供应商发货附件\\外协件\\${this.currentRow?.project?.trackId || ''}${this.currentRow?.projectName || ''}\\${this.currentRow?.procSupplier?.supplierName || ''}\\${this.currentRow?.formCode || ''}`);
                } else {
                    formData.append('filePath', `供应商发货附件\\未分类\\${this.currentRow?.formId || this.currentRow?.formCode || ''}`);
                }
            }
            formData.append('tableName', this.tableName);

            // 模拟上传请求
            uploadFileApi(formData, this).then(() => {
                this.uploading = false;
                this.selectedFiles = [];
                this.$message.success('文件上传成功');
            }).catch(() => {
                this.uploading = false;
                this.$message.error('文件上传失败');
            })
        },
        // 格式化文件大小
        formatFileSize(bytes) {
            if (bytes === 0) return '0 B';
            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },
    }
}

</script>
<style scoped>
.upload-area {
    border: 2px dashed #dcdfe6;
    border-radius: 6px;
    padding: 80px;
    text-align: center;
    margin-bottom: 10px;
    transition: border-color 0.3s;
    background: #fafafa;
    cursor: pointer;
}

.upload-area:hover {
    border-color: #409EFF;
}

.upload-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 15px;
}

.uploadParams {
    display: flex;
    gap: 10px;
    width: 100%;
    justify-content: right;
    align-items: center;
    text-align: left;
    margin-bottom: 5px;
}

.uploadFile>>>.el-dialog__body {
    padding: 0 20px;
}
</style>